import Old1PublicBackLink from "../components/old1_PublicBackLink";
import Old1PublicSiteNav from "../components/old1_PublicSiteNav";
import Old1PublicSiteFooter from "../components/old1_PublicSiteFooter";
import PublicInsightCard from "../../components/PublicInsightCard";
import PageSeo from "../../components/PageSeo";
import { PUBLIC_BLOG_POSTS } from "../../data/publicBlogPosts";

const OLD1_BLOG_POSTS = PUBLIC_BLOG_POSTS.map((post) => ({
  ...post,
  href: post.href.replace(/^\/blog/, "/old1/blog"),
}));

function old1_BlogIndexPage({ currentUser, setCurrentUser }) {
  return (
    <div className="home-page jw-public-page jw-public-home jw-public-blog-page">
      <PageSeo
        title="Insights & perspectives"
        description="Articles and videos on genuine hiring, broken job applications, and building a more human way to connect real people with real jobs."
        path="/old1/blog"
        schemaType="website"
      />

      <Old1PublicSiteNav currentUser={currentUser} setCurrentUser={setCurrentUser} />

      <main id="main-content" className="jw-public-main">
        <section className="jw-public-section jw-public-blog-index">
          <Old1PublicBackLink fallbackTo="/old1/home" fixed />

          <div className="jw-public-section-head jw-public-blog-index__head">
            <span className="jw-public-eyebrow">Read our blog</span>
            <h1>Insights &amp; perspectives</h1>
            <p className="jw-public-blog-index__lede">
              Articles and videos exploring trust, authenticity, and human connection in modern hiring.
            </p>
          </div>

          <div className="blog-grid jw-public-insight-grid jw-public-blog-index__grid">
            {OLD1_BLOG_POSTS.map((post) => (
              <PublicInsightCard key={post.href} {...post} />
            ))}
          </div>
        </section>
      </main>

      <Old1PublicSiteFooter />
    </div>
  );
}

export default old1_BlogIndexPage;
